import React from 'react';
import {
  Box,
} from '@chakra-ui/react';


/**
 * TODO: Currently there is no content.
 * To be filled in at a later time
 */
import HeadingWithText from '../../components/sections/headingwithtext'

export default function PranaTabPanel() {
  return (
    <Box>
      <HeadingWithText
        title="COMING SOON..."
      ></HeadingWithText>
    </Box>
  );
}
